import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { DropDown } from 'src/app/shared/model/base-model';

@Component({
    selector: 'sf-dropdown-icon-service',
    templateUrl: './dropdown-icon-service.component.html',
    styleUrls: ['./dropdown-icon-service.component.scss']

})

export class DropdownIconServiceComponent implements OnInit, OnChanges{

    @Input() icon: string;
    @Input() placeHolderLanguage: string;
    @Output() chosedIcon = new EventEmitter();

    public list: DropDown[];
    public selectedIcon: DropDown;

    ngOnInit(): void {
        this.getList();
        this.getSelected();
    }

    ngOnChanges(): void {
        this.getSelected();

    }

    feedback() {
        this.chosedIcon.emit(this.selectedIcon);
    }

    getSelected(){
        if (this.list !== null && this.list != undefined &&this.icon !== null){
            this.selectedIcon = this.list.find(x => x.id == this.icon);
        }
    }

    getList(){
        this.list = [
            {id: 'null', name: ''},
            { name: 'abertura-firma', id: 'abertura-firma.png' },
            { name: 'alteracao-contratual', id: 'alteracao-contratual.png' },
            { name: 'autenticacao', id: 'autenticacao.png' },
            { name: 'escritura', id: 'escritura.png' },
            { name: 'inventario', id: 'inventario.png' },
            { name: 'procuracao', id: 'procuracao.png' },
            { name: 'reconhecimento-firma', id: 'reconhecimento-firma.png' },
            { name: 'separacao-divorcio', id: 'separacao-divorcio.png' },
            { name: 'testamento', id: 'testamento.png' }

        ];
    }
}
